export default class CreateTransportCompanyStrategy {
  constructor(store) {
    this.store = store;
  }

  save(data) {
    return this.store.dispatch('company/createTransportCompany', data);
  }
}
